//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, { useState, useEffect, useContext } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import * as moment from "moment";

// custom pages
import { editStyles } from "./styles";
import settingsApi from "apis/settings/settings";
import Context from "context/context";

// material-ui
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { useTranslation } from 'react-i18next';
import { MenuItem } from '@material-ui/core'
import {
  DatePicker,
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { enUS, fr } from "date-fns/locale";

const formLabelsTheme = createMuiTheme({
  overrides: {
    MuiFormLabel: {
      asterisk: {
        color: "#db3131",
        "&$error": {
          color: "#db3131",
        },
      },
    },
  },
  palette: {
    primary: {
      main: "#000000",
    },
  },
});

const status = [
  {
    "label": "True",
    "value": true
  },
  {
    "label": "False",
    "value": false
  }
]

const org = [
  {
    "label": "Henry Schein Dental",
    "value": "Henry Schein Dental"
  },
  {
    "label": "Henry Schein Canada",
    "value": "Henry Schein Canada"
  }
]

const site = [
  {
    "label": "henryschein.com",
    "value": "henryschein.com"
  },
  {
    "label": "henryschein.ca",
    "value": "henryschein.ca"
  }
]

export default function EditSettings(props) {
  const { editSettings } = settingsApi();
  const { state, dispatch } = useContext(Context);

  const location = useLocation();
  const classes = editStyles();
  const [originalItem, setOrginalItem] = useState({});
  const [item, setitem] = useState({});
  const [updatedItem, setUpdatedItem] = useState({});
  const history = useHistory();
  const [loading, setLoading] = useState(false)
  const { t, i18n } = useTranslation();
  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "Settings"],
    });
  }, []);

  // setting input data
  useEffect(() => {
    if (location?.state && location?.state?.data) {
      setOrginalItem(location.state.data);
      setitem(location.state.data);
    }
  }, []);

  // input change func
  function handleChange(evt) {
    const value = evt.target.value;
   
   

    setitem({
      ...item,
      [evt.target.name]: value,
    });
    setUpdatedItem({
      ...updatedItem,
      [evt.target.name]: value,
    });
  }

  // update api func
  async function handleUpdate() {
    Object.keys(updatedItem).map((k) => {
      //console.log({ o: originalItem[k]?.toString(), u: updatedItem[k] });
      if (originalItem[k]?.toString() === updatedItem[k]) {
        delete updatedItem[k];
      }
    });
    if (updatedItem && Object.keys(updatedItem).length === 0) {
      return toast.error("Please update an value", { toastId: "empty-data-settings" });
    }
    let values = {};
    Object.keys(updatedItem).map((k) => {
      if (k === "points_to_dollar") {
        values = { ...values, [k]: updatedItem[k].toString() };
      } else if (k === 'qualified_purchase_days' || k === 'account_lock_attempt' || k === 'expiring_points_in_days' ||
        k === 'default_redemption' || k === 'max_redemption_points' || k === 'loyalty_start_value' ||
        k === 'loyalty_current_value' || k === 'promotion_current_value') {
        values = { ...values, [k]: parseInt(updatedItem[k]) };
      } else {
        values = { ...values, [k]: updatedItem[k] };
      }
    });

    try {
      setLoading(true)
      let res = await editSettings(values);
      setLoading(false)
      if (res.type === "success") {
        toast.success(res.message);
        history.goBack();
      } else {
        toast.error(res.message);
      }
    } catch (e) {
      setLoading(false)
      toast.error("Something Went Wrong");
    }
  }

  const blockInvalidChar = (e) =>
    ["e", "E", "+", "-", '.'].includes(e.key) && e.preventDefault();

    const blockInvalidCharRatio = (e) =>
    ["e", "E", "+", "-"].includes(e.key) && e.preventDefault();

  const locale = i18n.language == 'fr' ? fr : enUS;

  let onewebAccessTypes = [
    {
      label: 'None',
      value: 'RESTRICTED'
    },
    {
      label: 'All',
      value: 'ALLOWED'
    },
    {
      label: 'Partial',
      value: 'PARTIALLY_ALLOWED'
    }
  ];

  return (
    <React.Fragment>
      <Grid container style={{ paddingTop: 10 }}>
        <Grid item xs={6}>
          <Button
            className={classes.backBtn}
            onClick={() => {
              history.goBack();
            }}
          >
            {t('Back')}
          </Button>
        </Grid>
      </Grid>
      <Grid container className={classes.parentGrid}>
        <ThemeProvider theme={formLabelsTheme}>
          <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                id="standard-select-currency"
                name="points_to_dollar"
                label={
                  <span className={classes.pointsToDollar}>
                    {t('Points to Dollar($)')}
                  </span>
                }
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
                type="text"
                inputMode="decimal"
                // onKeyDown={blockInvalidChar}
                value={item.points_to_dollar}
                onChange={(e) => {
                  if (/^\d*\.?\d*$/.test(e.target.value)) {
                    handleChange(e);
                  }
                }}
              ></TextField>
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                id="standard-basic"
                name="qualified_purchase_days"
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
                label={
                  <span style={{ fontSize: "23px" }}>
                    {t('Qualified purchase days')}
                  </span>
                }
                className={classes.input}
                required
                type="text"
                inputMode="numeric"
                onKeyDown={blockInvalidChar}
                value={item.qualified_purchase_days}
                onChange={(e) => {
                  if (/^\d*\.?\d*$/.test(e.target.value)) {
                    handleChange(e);
                  }
                }}
              />
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                id="standard-basic"
                name="account_lock_attempt"
                label={
                  <span style={{ fontSize: "23px" }}>{t('Account lock attempt')}</span>
                }
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
                type="text"
                inputMode="numeric"
                onKeyDown={blockInvalidChar}
                value={item.account_lock_attempt}
                onChange={(e) => {
                  if (/^\d*\.?\d*$/.test(e.target.value)) {
                    handleChange(e);
                  }
                }}
              />
            </div>
          </Grid>

          <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                id="standard-basic"
                name="expiring_points_in_days"
                label={
                  <span style={{ fontSize: "23px" }}>
                    {t('Expiring Points in days')}
                  </span>
                }
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
                type="text"
                inputMode="numeric"
                onKeyDown={blockInvalidChar}
                value={item.expiring_points_in_days}
                onChange={(e) => {
                  if (/^\d*\.?\d*$/.test(e.target.value)) {
                    handleChange(e);
                  }
                }}
              />
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                id="standard-basic"
                name="default_redemption"
                label={
                  <span style={{ fontSize: "23px", marginBottom: "30px" }}>
                    {t('Default redemption')}
                  </span>
                }
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
                type="text"
                inputMode="numeric"
                onKeyDown={blockInvalidChar}
                value={item.default_redemption}
                onChange={(e) => {
                  if (/^\d*\.?\d*$/.test(e.target.value)) {
                    handleChange(e);
                  }
                }}
              />
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                id="standard-basic"
                name="max_redemption_points"
                label={
                  <span style={{ fontSize: "23px" }}>
                    {t('Max redemption points')}
                  </span>
                }
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
                type="text"
                inputMode="numeric"
                onKeyDown={blockInvalidChar}
                value={item.max_redemption_points}
                onChange={(e) => {
                  if (/^\d*\.?\d*$/.test(e.target.value)) {
                    handleChange(e);
                  }
                }}
              />
            </div>
          </Grid>

          <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                select
                id="standard-basic"
                name="is_active"
                label={<span style={{ fontSize: "23px" }}>{t('Is Active')}</span>}
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
                value={item.is_active === true ? true : false}
                onChange={handleChange}
              >
                {status.map((data, i) =>
                  <MenuItem key={i} value={data.value}>
                    {t(data.label)}
                  </MenuItem>
                )}</TextField>
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="MM/dd/yyyy"
                margin="normal"
                label={t("Tier execution date")}
                id="date-picker-inline"
                className={classes.dateInput}
                InputProps={{
                  classes: {
                    root: classes.dateInputTexts,
                  },
                }}
                value={item.tier_execution_date}
                // minDate={new Date()}
                // maxDate={new Date()}
                onChange={(date) => {
                  setitem({
                    ...item,
                    ["tier_execution_date"]: date,
                  });
                  setUpdatedItem({
                    ...updatedItem,
                    ["tier_execution_date"]: date,
                  });
                }}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
                autoOk
              />
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                select
                id="standard-basic"
                name="max_merch_cron_job"
                label={<span style={{ fontSize: "23px" }}>{t('Max merch cron job')}</span>}
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
                value={item.max_merch_cron_job === true ? true : false}
                onChange={handleChange}
              >
                {status.map((data, i) =>
                  <MenuItem key={i} value={data.value}>
                    {data.label}
                  </MenuItem>
                )}</TextField>
            </div>
          </Grid>

          <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                id="standard-basic"
                name="loyalty_start_value"
                label={
                  <span style={{ fontSize: "23px" }}>
                    {t('Loyalty start value')}
                  </span>
                }
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
                type="text"
                inputMode="numeric"
                onKeyDown={blockInvalidChar}
                value={item.loyalty_start_value}
                onChange={(e) => {
                  if (/^\d*\.?\d*$/.test(e.target.value)) {
                    handleChange(e);
                  }
                }}
              />
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                id="standard-basic"
                name="loyalty_current_value"
                label={
                  <span style={{ fontSize: "23px" }}>
                    {t('Loyalty current value')}
                  </span>
                }
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
                type="text"
                inputMode="numeric"
                onKeyDown={blockInvalidChar}
                value={item.loyalty_current_value}
                onChange={(e) => {
                  if (/^\d*\.?\d*$/.test(e.target.value)) {
                    handleChange(e);
                  }
                }}
              />
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                id="standard-basic"
                name="admin_consent_token_expiration"
                label={
                  <span style={{ fontSize: "23px" }}>
                    {t('Admin consent token expiration')}
                  </span>
                }
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
                type="text"
                onKeyDown={blockInvalidChar}
                value={item.admin_consent_token_expiration}
                onChange={handleChange}
              />
            </div>
          </Grid>

          <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                id="standard-basic"
                name="login_token_expiration"
                label={
                  <span style={{ fontSize: "23px" }}>
                    {t('Login token expiration')}
                  </span>
                }
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
                type="text"
                onKeyDown={blockInvalidChar}
                value={item.login_token_expiration}
                onChange={handleChange}
              />
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                id="standard-basic"
                name="signup_token_expiration"
                label={
                  <span style={{ fontSize: "23px" }}>
                    {t('Signup token expiration')}
                  </span>
                }
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
                type="text"
                onKeyDown={blockInvalidChar}
                value={item.signup_token_expiration}
                onChange={handleChange}
              />
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                id="standard-basic"
                name="promotion_current_value"
                label={
                  <span style={{ fontSize: "23px" }}>
                    {t('Promotion current value')}
                  </span>
                }
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
                type="text"
                onKeyDown={blockInvalidChar}
                value={item.promotion_current_value}
                onChange={handleChange}
              />
            </div>
          </Grid>

          <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                id="standard-basic"
                name="cookie_expiration"
                label={
                  <span style={{ fontSize: "23px" }}>
                    {t('Cookie expiration')}
                  </span>
                }
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
                type="text"
                onKeyDown={blockInvalidChar}
                value={item.cookie_expiration}
                onChange={handleChange}
              />
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                <KeyboardDatePicker
                  disableToolbar
                  variant="inline"
                  format="MM/dd/yyyy"
                  margin="normal"
                  label={t("Banner start date")}
                  id="date-picker-inline"
                  className={classes.dateInput}
                  InputProps={{
                    classes: {
                      root: classes.dateInputTexts,
                    },
                  }}
                  value={moment.utc(item.banner_start_date).format("MM-DD-YYYY")}
                  // minDate={new Date()}
                  // maxDate={new Date()}
                  onChange={(date) => {
                    if (moment(date).isAfter(item.banner_end_date)) {
                      toast.error("Start date should be greater than End date.", {
                        toastId: "banner-start-date-end-date",
                      });
                      return;
                    }
                    setitem({
                      ...item,
                      ["banner_start_date"]: date,
                    });
                    setUpdatedItem({
                      ...updatedItem,
                      ["banner_start_date"]: date,
                    });
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                  autoOk
                />
              </MuiPickersUtilsProvider>
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="MM/dd/yyyy"
                margin="normal"
                label={t("Banner end date")}
                id="date-picker-inline"
                className={classes.dateInput}
                InputProps={{
                  classes: {
                    root: classes.dateInputTexts,
                  },
                }}
                value={moment.utc(item.banner_end_date).format("MM-DD-YYYY")}
                // minDate={new Date()}
                // maxDate={new Date()}
                onChange={(date) => {
                  if (moment(item.banner_start_date).isAfter(date)) {
                    toast.error("Start date should be greater than End date.", {
                      toastId: "banner-start-date-end-date",
                    });
                    return;
                  }
                  setitem({
                    ...item,
                    ["banner_start_date"]: date,
                  });
                  setUpdatedItem({
                    ...updatedItem,
                    ["banner_start_date"]: date,
                  });
                }}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
                autoOk
              />
            </MuiPickersUtilsProvider>
          </Grid>

          <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                id="standard-basic"
                name="blob_sas_token"
                label={
                  <span style={{ fontSize: "23px" }}>
                    {t('Blob sas token')}
                  </span>
                }
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
                type="text"
                onKeyDown={blockInvalidChar}
                value={item.blob_sas_token}
                onChange={handleChange}
              />
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                select
                id="standard-basic"
                name="loyalty_organization_name"
                label={<span style={{ fontSize: "23px" }}>{t('Loyalty organization name')}</span>}
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
                value={item.loyalty_organization_name ? item.loyalty_organization_name : ""}
                onChange={handleChange}
              >
                {org.map((data, i) =>
                  <MenuItem key={i} value={data.value}>
                    {t(data.label)}
                  </MenuItem>
                )}</TextField>
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                select
                id="standard-basic"
                name="loyalty_site_id"
                label={<span style={{ fontSize: "23px" }}>{t('Loyalty site id')}</span>}
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
                value={item.loyalty_site_id ? item.loyalty_site_id : ""}
                onChange={handleChange}
              >
                {site.map((data, i) =>
                  <MenuItem key={i} value={data.value}>
                    {t(data.label)}
                  </MenuItem>
                )}</TextField>
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                select
                id="standard-basic"
                name="oneweb_login_access"
                label={<span style={{ fontSize: "23px" }}>{t('Oneweb Login Access')}</span>}
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
                value={item.oneweb_login_access ? item.oneweb_login_access : ""}
                onChange={handleChange}
              >
                {onewebAccessTypes.map((data, i) =>
                  <MenuItem key={i} value={data.value}>
                    {t(data.label)}
                  </MenuItem>
                )}</TextField>
            </div>
          </Grid><Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                select
                id="standard-basic"
                name="oneweb_enrollment_access"
                label={<span style={{ fontSize: "23px" }}>{t('Oneweb Enrollment Access')}</span>}
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
                value={item.oneweb_enrollment_access ? item.oneweb_enrollment_access : ""}
                onChange={handleChange}
              >
                {onewebAccessTypes.map((data, i) =>
                  <MenuItem key={i} value={data.value}>
                    {t(data.label)}
                  </MenuItem>
                )}</TextField>
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                select
                id="standard-basic"
                name="negative_points_active_status"
                label={<span style={{ fontSize: "23px" }}>{t('Negative Points Mail Sender')}</span>}
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
                value={typeof item.negative_points_active_status == 'boolean' ? item.negative_points_active_status : ""}
                onChange={handleChange}
              >
                {status.map((data, i) =>
                  <MenuItem key={i} value={data.value}>
                    {t(data.label)}
                  </MenuItem>
                )}
                

              </TextField>
            </div>
          </Grid>

          <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                id="standard-basic"
                name="min_signature_date"
                label={
                  <span style={{ fontSize: "23px" }}>
                    {t('Signature Minimum Date')}
                  </span>
                }
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
                type="text"
                inputMode="numeric"
                onKeyDown={blockInvalidChar}
                value={item.min_signature_date}
                onChange={(e) => {
                  if (/^\d*\.?\d*$/.test(e.target.value)) {
                    handleChange(e);
                  }
                }}
              />
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                select
                id="standard-basic"
                name="unconsented_deactivation_is_active"
                label={<span style={{ fontSize: "23px" }}>{t('Unconsented Deactivation Is Active')}</span>}
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
                value={item.unconsented_deactivation_is_active === true ? true : false}
                onChange={handleChange}
              >
                {status.map((data, i) =>
                  <MenuItem key={i} value={data.value}>
                    {t(data.label)}
                  </MenuItem>
                )}</TextField>
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                id="standard-basic"
                name="unconsented_deactivation_days"
                label={
                  <span style={{ fontSize: "23px" }}>
                    {t('Unconsented Deactivation Days')}
                  </span>
                }
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
                type="text"
                inputMode="numeric"
                onKeyDown={blockInvalidChar}
                value={item.unconsented_deactivation_days}
                onChange={(e) => {
                  if (/^\d*\.?\d*$/.test(e.target.value)) {
                    handleChange(e);
                  }
                }}
              />
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                id="standard-basic"
                name="user_password_reuse_limit"
                label={
                  <span style={{ fontSize: "23px" }}>
                    {t('User Password Reuse Limit')}
                  </span>
                }
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
                type="text"
                inputMode="numeric"
                onKeyDown={blockInvalidChar}
                value={item.user_password_reuse_limit}
                onChange={(e) => {
                  if (/^\d*\.?\d*$/.test(e.target.value)) {
                    handleChange(e);
                  }
                }}
              />
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                id="standard-basic"
                name="user_password_expiration_days"
                label={
                  <span style={{ fontSize: "23px" }}>
                    {t('User Password Expiraion Days')}
                  </span>
                }
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
                type="text"
                inputMode="numeric"
                onKeyDown={blockInvalidChar}
                value={item.user_password_expiration_days}
                onChange={(e) => {
                  if (/^\d*\.?\d*$/.test(e.target.value)) {
                    handleChange(e);
                  }
                }}
              />
            </div>
          </Grid>

          <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                select
                id="standard-basic"
                name="activation_remainder"
                label={<span style={{ fontSize: "23px" }}>{t('Activation_Remainder Mail Sender')}</span>}
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
                value={typeof item.activation_remainder == 'boolean' ? item.activation_remainder : ""}
                onChange={handleChange}
              >
                {status.map((data, i) =>
                  <MenuItem key={i} value={data.value}>
                    {t(data.label)}
                  </MenuItem>
                )}
              </TextField>
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                select
                id="standard-basic"
                name="allow_redemption"
                label={<span style={{ fontSize: "23px" }}>{t('Allow_Redemption')}</span>}
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
                value={typeof item.allow_redemption == 'boolean' ? item.allow_redemption : ""}
                onChange={handleChange}
              >
                {status.map((data, i) =>
                  <MenuItem key={i} value={data.value}>
                    {t(data.label)}
                  </MenuItem>
                )}
                
                </TextField>
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                id="standard-basic"
                name="min_thrive_back_date"
                label={
                  <span style={{ fontSize: "23px" }}>
                    {t('Thrive Rewards Minimum Date')}
                  </span>
                }
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
                type="text"
                inputMode="numeric"
                onKeyDown={blockInvalidChar}
                value={item.min_thrive_back_date}
                onChange={(e) => {
                  if (/^\d*\.?\d*$/.test(e.target.value)) {
                    handleChange(e);
                  }
                }}
              />
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                <KeyboardDatePicker
                  disableToolbar
                  variant="inline"
                  format="MM/dd/yyyy"
                  margin="normal"
                  label={t("Annual Statement Mail Sender Date")}
                  id="date-picker-inline"
                  className={classes.dateInput}
                  InputProps={{
                    classes: {
                      root: classes.dateInputTexts,
                    },
                  }}
                  value={
                    item.annual_statement_mail_sender_date
                      ? new Date(item.annual_statement_mail_sender_date)
                      : null
                  }
                  onChange={(date) => {
                    setitem({
                      ...item,
                      annual_statement_mail_sender_date: date, 
                    });
                    setUpdatedItem({
                      ...updatedItem,
                      annual_statement_mail_sender_date: date, 
                    });
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                  autoOk
                />
              </MuiPickersUtilsProvider>
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                id="standard-basic"
                name="signature_statement_month"
                label={
                  <span style={{ fontSize: "23px" }}>
                    {t('Signature Statement Month')}
                  </span>
                }
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
                type="text"
                inputMode="numeric"
                onKeyDown={blockInvalidChar}
                value={item.signature_statement_month}
                onChange={(e) => {
                  if (/^\d*\.?\d*$/.test(e.target.value)) {
                    handleChange(e);
                  }
                }}
              />
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                id="standard-basic"
                name="dormant_account"
                label={
                  <span style={{ fontSize: "23px" }}>
                    {t('Dormant Account')}
                  </span>
                }
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
                type="text"
                inputMode="numeric"
                onKeyDown={blockInvalidChar}
                value={item.dormant_account}
                onChange={(e) => {
                  if (/^\d*\.?\d*$/.test(e.target.value)) {
                    handleChange(e);
                  }
                }}
              />
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                select
                id="standard-basic"
                name="dormant_reminder"
                label={<span style={{ fontSize: "23px" }}>{t('Dormant_Reminder')}</span>}
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
                value={typeof item.dormant_reminder == 'boolean' ? item.dormant_reminder : ""}
                onChange={handleChange}
              >
                {status.map((data, i) =>
                  <MenuItem key={i} value={data.value}>
                    {t(data.label)}
                  </MenuItem>
                )}
                
                </TextField>
            </div>
          </Grid>

          <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                select
                id="standard-basic"
                name="is_gep_signup_api_enabled"
                label={<span style={{ fontSize: "23px" }}>{t('GEP Signup API')}</span>}
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
                value={typeof item.is_gep_signup_api_enabled == 'boolean' ? item.is_gep_signup_api_enabled : ""}
                onChange={handleChange}
              >
                {status.map((data, i) =>
                  <MenuItem key={i} value={data.value}>
                    {t(data.label)}
                  </MenuItem>
                )}
                
                </TextField>
            </div>
          </Grid>

          <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                select
                id="standard-basic"
                name="is_gep_login_api_enabled"
                label={<span style={{ fontSize: "23px" }}>{t('GEP Login API')}</span>}
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
                value={typeof item.is_gep_login_api_enabled == 'boolean' ? item.is_gep_login_api_enabled : ""}
                onChange={handleChange}
              >
                {status.map((data, i) =>
                  <MenuItem key={i} value={data.value}>
                    {t(data.label)}
                  </MenuItem>
                )}
                
                </TextField>
            </div>
          </Grid>

          <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                select
                id="standard-basic"
                name="is_gep_points_balance_api_enabled"
                label={<span style={{ fontSize: "23px" }}>{t('GEP Points Balance API')}</span>}
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
                value={typeof item.is_gep_points_balance_api_enabled == 'boolean' ? item.is_gep_points_balance_api_enabled : ""}
                onChange={handleChange}
              >
                {status.map((data, i) =>
                  <MenuItem key={i} value={data.value}>
                    {t(data.label)}
                  </MenuItem>
                )}
                
                </TextField>
            </div>
          </Grid>

          <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                select
                id="standard-basic"
                name="enable_gep_sync"
                label={<span style={{ fontSize: "23px" }}>{t('Enable_gep_sync')}</span>}
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
                value={typeof item.enable_gep_sync == 'boolean' ? item.enable_gep_sync : ""}
                onChange={handleChange}
              >
                {status.map((data, i) =>
                  <MenuItem key={i} value={data.value}>
                    {t(data.label)}
                  </MenuItem>
                )}
                
                </TextField>
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                select
                id="standard-basic"
                name="is_gep_response_enabled"
                label={<span style={{ fontSize: "23px" }}>{t('GEP Response')}</span>}
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
                value={typeof item.is_gep_response_enabled == 'boolean' ? item.is_gep_response_enabled : ""}
                onChange={handleChange}
              >
                {status.map((data, i) =>
                  <MenuItem key={i} value={data.value}>
                    {t(data.label)}
                  </MenuItem>
                )}
                
                </TextField>
            </div>
          </Grid>

          <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                select
                id="standard-basic"
                name="is_gep_redirection_link_enabled"
                label={<span style={{ fontSize: "23px" }}>{t('GEP Redirection Enable')}</span>}
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
                value={typeof item.is_gep_redirection_link_enabled == 'boolean' ? item.is_gep_redirection_link_enabled : ""}
                onChange={handleChange}
              >
                {status.map((data, i) =>
                  <MenuItem key={i} value={data.value}>
                    {t(data.label)}
                  </MenuItem>
                )}
                
                </TextField>
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                id="standard-basic"
                name="email_count"
                label={
                  <span style={{ fontSize: "23px" }}>
                    {t('Email Count')}
                  </span>
                }
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
                type="text"
                inputMode="numeric"
                onKeyDown={blockInvalidChar}
                value={item.email_count}
                onChange={(e) => {
                  if (/^\d*\.?\d*$/.test(e.target.value)) {
                    handleChange(e);
                  }
                }}
              />
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                id="standard-basic"
                name="content"
                label={
                  <span style={{ fontSize: "23px" }}>
                    {t('Content')}
                  </span>
                }
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
               
                onKeyDown={blockInvalidChar}
                value={item.content}
                onChange={handleChange}
              />
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                select
                id="standard-basic"
                name="activation_remainder_US"
                label={<span style={{ fontSize: "23px" }}>{t('TR Activation Remainder US')}</span>}
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
                value={typeof item.activation_remainder_US == 'boolean' ? item.activation_remainder_US : ""}
                onChange={handleChange}
              >
                {status.map((data, i) =>
                  <MenuItem key={i} value={data.value}>
                    {t(data.label)}
                  </MenuItem>
                )}
                
                </TextField>
            </div>
          </Grid>

          
          {state?.userInfo?.loyalty_organization_name==="Henry Schein Dental"?(
          <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                select
                id="standard-basic"
                name="HSD_Sync"
                label={<span style={{ fontSize: "23px" }}>{t('HSD Sync')}</span>}
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
                value={typeof item.HSD_Sync == 'boolean' ? item.HSD_Sync : ""}
                onChange={handleChange}
              >
                {status.map((data, i) =>
                  <MenuItem key={i} value={data.value}>
                    {t(data.label)}
                  </MenuItem>
                )}
                
                </TextField>
            </div>
          </Grid>
          ):null}

          <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                <KeyboardDatePicker
                  disableToolbar
                  variant="inline"
                  format="MM/dd/yyyy"
                  margin="normal"
                  label={t("Google Analytics Start Date")}
                  id="date-picker-inline"
                  className={classes.dateInput}
                  InputProps={{
                    classes: {
                      root: classes.dateInputTexts,
                    },
                  }}
                  value={
                    item.google_analytics_start_date
                      ? new Date(item.google_analytics_start_date)
                      : null
                  }
                  onChange={(date) => {
                    setitem({
                      ...item,
                      google_analytics_start_date: date, 
                    });
                    setUpdatedItem({
                      ...updatedItem,
                      google_analytics_start_date: date, 
                    });
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                  autoOk
                />
              </MuiPickersUtilsProvider>
            </div>
          </Grid>
          {state?.userInfo?.loyalty_organization_name==="Henry Schein Dental"?(
          <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                <KeyboardDatePicker
                  disableToolbar
                  variant="inline"
                  format="MM/dd/yyyy"
                  margin="normal"
                  label={t("Quarter End Date")}
                  id="date-picker-inline"
                  className={classes.dateInput}
                  InputProps={{
                    classes: {
                      root: classes.dateInputTexts,
                    },
                  }}
                  value={
                    item.quarter_end_date
                      ? new Date(item.quarter_end_date)
                      : null
                  }
                  onChange={(date) => {
                    setitem({
                      ...item,
                      quarter_end_date: date, 
                    });
                    setUpdatedItem({
                      ...updatedItem,
                      quarter_end_date: date, 
                    });
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                  autoOk
                />
              </MuiPickersUtilsProvider>
            </div>
          </Grid>
          ):null}


            {state?.userInfo?.loyalty_organization_name==="Henry Schein Dental"?(
            <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                id="standard-basic"
                name="dormant_reason"
                label={
                  <span style={{ fontSize: "23px" }}>
                    {t('Dormant Reason')}
                  </span>
                }
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
               
                onKeyDown={blockInvalidChar}
                value={item.dormant_reason}
                onChange={handleChange}
              />
            </div>
          </Grid>
            ):null}
 {state?.userInfo?.loyalty_organization_name==="Henry Schein Dental"?(
           <Grid xs={12} sm={4} lg={4}>
           <div style={{ paddingBottom: 51 }}>
             <TextField
               id="standard-select-ratio"
               name="startup_ratio"
               label={
                 <span className={classes.pointsToDollar}>
                   {t('Startup Ratio')}
                 </span>
               }
               className={classes.input}
               required
               InputProps={{
                 classes: {
                   root: classes.texts,
                 },
               }}
               type="text"
                inputMode="decimal"
              //  onKeyDown={blockInvalidCharRatio}
               value={item.startup_ratio}
               onChange={(e) => {
                if (/^\d*\.?\d*$/.test(e.target.value)) {
                  handleChange(e);
                }
              }}
             ></TextField>
           </div>
         </Grid>
            ):null}
             {state?.userInfo?.loyalty_organization_name==="Henry Schein Dental"?(
            <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                id="standard-basic"
                name="startup_first_date"
                label={
                  <span style={{ fontSize: "23px" }}>
                    {t('Startup First Date')}
                  </span>
                }
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
               
                onKeyDown={blockInvalidChar}
                value={item.startup_first_date}
                onChange={handleChange}
              />
            </div>
          </Grid>
            ):null}

{state?.userInfo?.loyalty_organization_name==="Henry Schein Dental"?(
          <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                select
                id="standard-basic"
                name="auto_redemption_flag"
                label={<span style={{ fontSize: "23px" }}>{t('Startup Auto Redemption')}</span>}
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
                value={typeof item.auto_redemption_flag == 'boolean' ? item.auto_redemption_flag : ""}
                onChange={handleChange}
              >
                {status.map((data, i) =>
                  <MenuItem key={i} value={data.value}>
                    {t(data.label)}
                  </MenuItem>
                )}
                
                </TextField>
            </div>
          </Grid>
          ):null}

          {state?.userInfo?.loyalty_organization_name==="Henry Schein Dental"?(
          <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                select
                id="standard-basic"
                name="Earn_Flag"
                label={<span style={{ fontSize: "23px" }}>{t('Earn Flag')}</span>}
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
                value={typeof item.Earn_Flag == 'boolean' ? item.Earn_Flag : ""}
                onChange={handleChange}
              >
                {status.map((data, i) =>
                  <MenuItem key={i} value={data.value}>
                    {t(data.label)}
                  </MenuItem>
                )}
                
                </TextField>
            </div>
          </Grid>):null}

          {state?.userInfo?.loyalty_organization_name==="Henry Schein Dental"?(
          <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                select
                id="standard-basic"
                name="Recurring_Flag"
                label={<span style={{ fontSize: "23px" }}>{t('Recurring Flag')}</span>}
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
                value={typeof item.Recurring_Flag == 'boolean' ? item.Recurring_Flag : ""}
                onChange={handleChange}
              >
                {status.map((data, i) =>
                  <MenuItem key={i} value={data.value}>
                    {t(data.label)}
                  </MenuItem>
                )}
                
                </TextField>
            </div>
          </Grid> ):null}
          
          {state?.userInfo?.loyalty_organization_name==="Henry Schein Dental"?(
          <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                select
                id="standard-basic"
                name="backdate_mail_sender_flag"
                label={<span style={{ fontSize: "23px" }}>{t('Backdate Mail Sender Flag')}</span>}
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
                value={typeof item.backdate_mail_sender_flag == 'boolean' ? item.backdate_mail_sender_flag : ""}
                onChange={handleChange}
              >
                {status.map((data, i) =>
                  <MenuItem key={i} value={data.value}>
                    {t(data.label)}
                  </MenuItem>
                )}
                
                </TextField>
            </div>
          </Grid>
          ):null}


{state?.userInfo?.loyalty_organization_name==="Henry Schein Dental"?(
            <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                id="standard-basic"
                name="billing_amount"
                label={
                  <span style={{ fontSize: "23px" }}>
                    {t('Billing Amount')}
                  </span>
                }
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
                type="text"
                inputMode="numeric"
                onKeyDown={blockInvalidChar}
                value={item.billing_amount}
                onChange={(e) => {
                  if (/^\d*\.?\d*$/.test(e.target.value)) {
                    handleChange(e);
                  }
                }}
              />
            </div>
          </Grid>
           ):null}
    {state?.userInfo?.loyalty_organization_name==="Henry Schein Dental"?(
            <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                id="standard-basic"
                name="unlock_bonus_points"
                label={
                  <span style={{ fontSize: "23px" }}>
                    {t('Unlock Bonus Points')}
                  </span>
                }
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
                type="text"
                inputMode="numeric"
                onKeyDown={blockInvalidChar}
                value={item.unlock_bonus_points}
                onChange={(e) => {
                  if (/^\d*\.?\d*$/.test(e.target.value)) {
                    handleChange(e);
                  }
                }}
              />
            </div>
          </Grid>
           ):null}

    {state?.userInfo?.loyalty_organization_name==="Henry Schein Dental"?(
           <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                id="standard-basic"
                name="unlock_backdate"
                label={
                  <span style={{ fontSize: "23px" }}>
                    {t('Unlock Minimum Date')}
                  </span>
                }
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
                type="text"
                inputMode="numeric"
                onKeyDown={blockInvalidChar}
                value={item.unlock_backdate}
                onChange={(e) => {
                  if (/^\d*\.?\d*$/.test(e.target.value)) {
                    handleChange(e);
                  }
                }}
              />
            </div>
          </Grid>
          ):null}

{state?.userInfo?.loyalty_organization_name==="Henry Schein Dental"?(
          <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                select
                id="standard-basic"
                name="billing_notification"
                label={<span style={{ fontSize: "23px" }}>{t('Billing Notification')}</span>}
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
                value={typeof item.billing_notification == 'boolean' ? item.billing_notification : ""}
                onChange={handleChange}
              >
                {status.map((data, i) =>
                  <MenuItem key={i} value={data.value}>
                    {t(data.label)}
                  </MenuItem>
                )}
                
                </TextField>
            </div>
          </Grid>
          ):null}

          {state?.userInfo?.loyalty_organization_name==="Henry Schein Dental"?(
          <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                select
                id="standard-basic"
                name="welcome_bonus_flag"
                label={<span style={{ fontSize: "23px" }}>{t('Welcome Bonus Flag')}</span>}
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
                value={typeof item.welcome_bonus_flag == 'boolean' ? item.welcome_bonus_flag : ""}
                onChange={handleChange}
              >
                {status.map((data, i) =>
                  <MenuItem key={i} value={data.value}>
                    {t(data.label)}
                  </MenuItem>
                )}
                
                </TextField>
            </div>
          </Grid>
          ):null}

          
           {state?.userInfo?.loyalty_organization_name==="Henry Schein Dental"?(
          <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                select
                id="standard-basic"
                name="unlock_qualified_flag"
                label={<span style={{ fontSize: "23px" }}>{t('Unlock Qualified Flag')}</span>}
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
                value={typeof item.unlock_qualified_flag == 'boolean' ? item.unlock_qualified_flag : ""}
                onChange={handleChange}
              >
                {status.map((data, i) =>
                  <MenuItem key={i} value={data.value}>
                    {t(data.label)}
                  </MenuItem>
                )}
                
                </TextField>
            </div>
          </Grid>
          ):null}

          
{state?.userInfo?.loyalty_organization_name==="Henry Schein Dental"?(
            <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                id="standard-basic"
                name="unlock_qualified_amount"
                label={
                  <span style={{ fontSize: "23px" }}>
                    {t('Unlock Qualified Amount')}
                  </span>
                }
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
                type="text"
                inputMode="numeric"
                onKeyDown={blockInvalidChar}
                value={item.unlock_qualified_amount}
                onChange={(e) => {
                  if (/^\d*\.?\d*$/.test(e.target.value)) {
                    handleChange(e);
                  }
                }}
              />
            </div>
          </Grid>
           ):null}

           
{state?.userInfo?.loyalty_organization_name==="Henry Schein Dental"?(
            <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                id="standard-basic"
                name="master_min_amount"
                label={
                  <span style={{ fontSize: "23px" }}>
                    {t('Master List Amount')}
                  </span>
                }
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
                type="text"
                inputMode="numeric"
                onKeyDown={blockInvalidChar}
                value={item.master_min_amount}
                onChange={(e) => {
                  if (/^\d*\.?\d*$/.test(e.target.value)) {
                    handleChange(e);
                  }
                }}
              />
            </div>
          </Grid>
           ):null}

           {state?.userInfo?.loyalty_organization_name==="Henry Schein Dental"?(
          <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                select
                id="standard-basic"
                name="growth_bonus_customer_email_flag"
                label={<span style={{ fontSize: "23px" }}>{t('Growth Bonus Customer Email Flag')}</span>}
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
                value={typeof item.growth_bonus_customer_email_flag == 'boolean' ? item.growth_bonus_customer_email_flag : ""}
                onChange={handleChange}
              >
                {status.map((data, i) =>
                  <MenuItem key={i} value={data.value}>
                    {t(data.label)}
                  </MenuItem>
                )}
                
                </TextField>
            </div>
          </Grid>
          ):null}

          {state?.userInfo?.loyalty_organization_name==="Henry Schein Dental"?(
          <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                select
                id="standard-basic"
                name="growth_bonus_fsc_email_flag"
                label={<span style={{ fontSize: "23px" }}>{t('Growth Bonus FSC Email Flag')}</span>}
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
                value={typeof item.growth_bonus_fsc_email_flag == 'boolean' ? item.growth_bonus_fsc_email_flag : ""}
                onChange={handleChange}
              >
                {status.map((data, i) =>
                  <MenuItem key={i} value={data.value}>
                    {t(data.label)}
                  </MenuItem>
                )}
                
                </TextField>
            </div>
          </Grid>
          ):null}
            {/* {state?.userInfo?.loyalty_organization_name==="Henry Schein Canada"?(
          <Grid xs={12} sm={4} lg={4}>
            <div style={{ paddingBottom: 51 }}>
              <TextField
                select
                id="standard-basic"
                name="bumpup_email_flag"
                label={<span style={{ fontSize: "23px" }}>{t('Bumpup Email Flag')}</span>}
                className={classes.input}
                required
                InputProps={{
                  classes: {
                    root: classes.texts,
                  },
                }}
                value={typeof item.bumpup_email_flag == 'boolean' ? item.bumpup_email_flag : ""}
                onChange={handleChange}
              >
                {status.map((data, i) =>
                  <MenuItem key={i} value={data.value}>
                    {t(data.label)}
                  </MenuItem>
                )}
                
                </TextField>
            </div>
          </Grid>
          ):null} */}

          <Grid xs={12} sm={4} lg={4} className={classes.btnGrid}>
            <Button
              className={classes.btn}
              onClick={() => {
                handleUpdate();
              }}
            >
              {loading ? 'loading..' : 'save'}
            </Button>
          </Grid>
        </ThemeProvider>
      </Grid>
    </React.Fragment>
  );
}
